import { Bubble, Dropdown } from 'tea-component';
// import close from '@/assets/svg/explore-analysis-close.svg';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { EntryComponent, TEntryChangeOptions } from '../interface';
import { FilterEntryMap } from '../configuration';
import { FilterMethod } from '@dbl/core/filter';
import React from 'react';
import { FieldSelect } from '../widgets/FieldSelect';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useDblIntl } from "@/pages/datalab/utils/utils";

export function FilterItem(props: {
  column: IColumnInfo;
  optionFilters: any[];
  handle: any;
  selectedItems: string[];
  onSelectItem: (newItemName: string) => void;
  customOptionLoader?: (column: IColumnInfo, gameCode: string) => Promise<any[]>;
  regionCountries?: any[];
  popularList?: any[];
  fieldSelectClassName?: string;
  handleContent?: (option: any) => React.ReactNode;
  filterEntryMap?: Record<string, EntryComponent>;
}) {
  const { commonFormatMessage, isEn } = useDblIntl("exploration");
  const {
    column,
    optionFilters,
    selectedItems,
    handle,
    onSelectItem,
    customOptionLoader,
    regionCountries,
    popularList,
    fieldSelectClassName = '',
    filterEntryMap,
    handleContent
  } = props;
  const { removeItem, notifyItems } = handle;
  const FilterEntry: EntryComponent = filterEntryMap?.[column.filter_method ?? FilterMethod.None] || FilterEntryMap[column.filter_method ?? FilterMethod.None] || FilterEntryMap[FilterMethod.None];
  const onEntryChange = (act: any, values: any[], text?: string, options?: TEntryChangeOptions) => {
    column.column_text = text;
    column.operation = act;
    column.column_value = values;
    if (options?.isAll !== undefined) {
      column.isAll = options.isAll;
    }
    notifyItems();
  };
  return (
    <div className="total-tab">
      <Dropdown className="dtl-tab-field-select" appearance="button" button={isEn ? column.column_display_en : column.column_display} clickClose={false}>
        <FieldSelect
          className={fieldSelectClassName ?? ''}
          fieldValue={column.column_name}
          fieldSelected={selectedItems}
          fieldOptions={optionFilters}
          onSelectItem={onSelectItem}
          handleContent={handleContent}
        />
      </Dropdown>
      <FilterEntry
        column={column}
        onChange={onEntryChange}
        handle={handle}
        isEn={isEn}
        customOptionLoader={customOptionLoader}
        regionCountries={regionCountries}
        popularList={popularList}
      />
      <Bubble dark content={commonFormatMessage("delete")}>
        <i
          className="label-close"
          onClick={() => {
            removeItem(column);
          }}
        >
          <SvgIcon type="clonse" />
        </i>
      </Bubble>

    </div>
  );
}
